// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/welcome-frontend/" + {"220":"P6Bx","235":"uurv","380":"yaP1","382":"K_VX","410":"PzS-","450":"mf3M","458":"os6v"}[chunkId] + "-" + {"220":"bf869be0415a","235":"3c7426cb0bff","380":"98c6b5215624","382":"1d0e8c5930cc","410":"873e4d1bcf6d","450":"02e5ff0428c7","458":"347450cd38a2"}[chunkId] + ".css";
};